import avatarIndividualMale from '../assets/images/avatar-individual-male.jpg';
import avatarIndividualFemale from '../assets/images/avatar-individual-female.jpg';
import avatarTeamMen from '../assets/images/avatar-team-men.jpg';
import avatarTeamWomen from '../assets/images/avatar-team-women.jpg';
import avatarTeamMixed from '../assets/images/avatar-team-mixed.jpg';

const normalizeGender = (value) =>
  String(value || '')
    .trim()
    .toLowerCase();

export const getIndividualAvatar = (gender) => {
  const g = normalizeGender(gender);
  if (g === 'female' || g === 'f' || g === 'mujer' || g === 'women') {
    return avatarIndividualFemale;
  }
  return avatarIndividualMale;
};

export const getTeamAvatar = (gender) => {
  const g = normalizeGender(gender);
  if (g === 'mixed' || g === 'mixto') return avatarTeamMixed;
  if (g === 'men' || g === 'male' || g === 'hombres' || g === 'hombre') {
    return avatarTeamMen;
  }
  if (g === 'women' || g === 'female' || g === 'mujeres' || g === 'mujer') {
    return avatarTeamWomen;
  }
  return avatarTeamMen;
};
